// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"247":"34dcc9e5ef068e79","494":"6d96e166af68e0a7"}[chunkId] + ".css";
};